import { RouteComponentProps } from 'react-router-dom';
import { parse } from '@tock/query-string';

import { IWithContextProps, withContext } from '@tock/coretypes';
import { Link, Typography } from 'omakase';
import BaseComponent from '@tock/shared/components/BaseComponent';
import FocusedPanel from 'components/focused-panel/FocusedPanel';
import ForgotPasswordForm from 'forms/ForgotPasswordForm';
import Section from 'components/Section';
import SectionHeader from 'components/SectionHeader';
import connect, { DefaultConnectProps } from '@tock/shared/utils/connect';

export interface ForgotPasswordValues {
  email: string;
}

interface OwnProps {
  baseRoute?: string;
}

class ForgotPasswordRoute extends BaseComponent<
  DefaultConnectProps & RouteComponentProps & IWithContextProps & OwnProps
> {
  componentDidMount() {
    this.props.actions.navigation.set({
      title: `Forgot your password?`,
      hasBack: true,
      goBackTo: `/login`,
    });
  }

  handleForgotPassword(formValues: ForgotPasswordValues) {
    const { actions, history, location } = this.props;
    const query = parse(location.search);
    const success = () => {
      if (query.continue) {
        history.push({
          pathname: query.continue,
        });
      } else {
        this.props.routeTo({
          pathname: '/login',
        });
      }
    };

    return actions.app.resetPassword(formValues.email, 'MANUAL').then(success);
  }

  render() {
    const { baseRoute } = this.props;

    const signupLink = `${baseRoute ?? ''}/signup`;

    return (
      <Section>
        <SectionHeader heading="Forgot your password?" />
        <FocusedPanel>
          <ForgotPasswordForm onSubmit={this.handleForgotPassword} />
          <div className="LoginForm-signUpLinkContainer">
            <Typography variant="body02">
              New to Tock?&nbsp;
              <Link href={signupLink}>Create an account</Link>
            </Typography>
          </div>
        </FocusedPanel>
      </Section>
    );
  }
}

export default connect<RouteComponentProps & OwnProps>(withContext(ForgotPasswordRoute));
